/*
 *  Binance Staking > 項目列表
 *  Binance Staking > 項目列表 > 項目詳情
 *  Binance Staking > 項目列表 > 我的返利
 */
export default {
  '/staking/list': {
    'exchange-staking-breadcrumb': '/staking',
    'exchange-staking-products-breadcrumb': '',
  },
  '/staking/detail': {
    'exchange-staking-breadcrumb': '/staking',
    'exchange-staking-products-breadcrumb': '/staking/products',
    'exchange-staking-product-detail-breadcrumb': '',
  },
  '/staking/earning': {
    'exchange-staking-breadcrumb': '/staking',
    'exchange-staking-products-breadcrumb': '/staking/products',
    'exchange-staking-product-earning-breadcrumb': '',
  },
  '/staking/explain': {
    'exchange-staking-breadcrumb': '/staking',
    'exchange-staking-product-explain-breadcrumb': '',
  },
};
